import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tbottom: ", ";\n\t\tleft: ", ";\n\t\tposition: absolute;\n\t\tright: ", ";\n\t\ttop: ", ";\n\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tbackground: rgba(0, 0, 0, 0.5);\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\toverflow-y: auto;\n\t\tpadding: ", ";\n\t\tperspective: 800px;\n\t\tposition: fixed;\n\t\tright: 0;\n\t\ttop: 0;\n\t\ttransition: ", ";\n\t\tz-index: ", ";\n\n\t\t&[data-enter] {\n\t\t\topacity: 1;\n\t\t}\n\n\t\t", ";\n\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { __ } from '@wordpress/i18n';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx, getZIndex, reducedMotion, space } from '@wp-g2/styles';
import React from 'react';
import { Dialog, DialogBackdrop, useDialogState } from 'reakit';
import { Portal } from '../Portal';
import { View } from '../View';
import { ModalContext, useModalState } from './BaseModal.Context';

function BaseModal(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'BaseModal'),
      _useContextSystem$bac = _useContextSystem.backdropTransitionDuration,
      backdropTransitionDuration = _useContextSystem$bac === void 0 ? 250 : _useContextSystem$bac,
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      _useContextSystem$lab = _useContextSystem.label,
      label = _useContextSystem$lab === void 0 ? __('Modal') : _useContextSystem$lab,
      _useContextSystem$ren = _useContextSystem.renderTrigger,
      renderTrigger = _useContextSystem$ren === void 0 ? null : _useContextSystem$ren,
      state = _useContextSystem.state,
      _useContextSystem$tra = _useContextSystem.transitionTimingFunction,
      transitionTimingFunction = _useContextSystem$tra === void 0 ? 'ease-in-out' : _useContextSystem$tra,
      _useContextSystem$tri = _useContextSystem.trigger,
      trigger = _useContextSystem$tri === void 0 ? null : _useContextSystem$tri,
      _useContextSystem$vis = _useContextSystem.visible,
      visible = _useContextSystem$vis === void 0 ? false : _useContextSystem$vis,
      zIndex = _useContextSystem.zIndex,
      otherProps = _objectWithoutProperties(_useContextSystem, ["backdropTransitionDuration", "children", "className", "label", "renderTrigger", "state", "transitionTimingFunction", "trigger", "visible", "zIndex"]);

  var _dialog = useDialogState({
    animated: true,
    visible: visible
  });

  var dialog = state || _dialog;

  var _useModalState = useModalState(dialog),
      isUnderLayer = _useModalState.isUnderLayer;

  var backdropStyles = css(_templateObject(), space(4), "opacity " + backdropTransitionDuration + "ms\n    " + transitionTimingFunction, zIndex || getZIndex('Modal'), reducedMotion("\n\t\t\t&[data-leave] {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t"));
  var dialogWrapperStyles = css(_templateObject2(), space(4), space(4), space(4), space(4));

  var dialogProps = _objectSpread(_objectSpread({}, otherProps), dialog);

  if (isUnderLayer) {
    dialogProps['data-underlayer'] = '';
  }

  var triggerProp = trigger || renderTrigger;
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      dialog: dialog
    }
  }, typeof triggerProp === 'function' ? triggerProp(dialog) : triggerProp ? triggerProp : null, /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(DialogBackdrop, Object.assign({}, dialog, {
    className: cx(backdropStyles)
  }), /*#__PURE__*/React.createElement(View, {
    className: dialogWrapperStyles
  }, /*#__PURE__*/React.createElement(Dialog, Object.assign({
    "aria-label": label,
    className: className,
    ref: forwardedRef,
    tabIndex: 0
  }, dialog, dialogProps), (dialog.visible || dialog.animating) && children)))));
}

export default contextConnect(BaseModal, 'BaseModal');